<template>
  <v-card
    class="d-flex flex-column justify-space-between align-center pa-6"
    flat
    tile
    :height="!isMobileBreakpoint ? 548 : ''"
  >
    <div class="w-full d-flex justify-end">
      <v-btn icon @click="handleClose">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="container-title">
      <h1 class="body-bold-xlarge mt-4">
        {{
          isSubtitle
            ? $t('message.ai.subtitles.addSubtitle')
            : $t('message.ai.dubbings.addDubbing')
        }}
      </h1>
      <span class="body-regular-base neutral-40-light--text">{{
        isSubtitle
          ? $t('message.ai.subtitles.addSubtitleDescription')
          : $t('message.ai.dubbings.addDubbingDescription')
      }}</span>
    </div>
    <div
      style="
        display: flex;
        gap: 24px;
        margin-bottom: 80px;
        margin-top: 40px;
        height: 380px;
      "
      :class="{ 'flex-column': isMobileBreakpoint }"
    >
      <div
        class="container-card-options"
        :class="{ 'w-full': isMobileBreakpoint }"
      >
        <img
          width="66px"
          height="40px"
          :src="require('@/assets/panda-brand-ia.png')"
        />
        <h1 class="body-bold-base mt-1">
          {{
            isSubtitle
              ? $t('message.ai.subtitles.subtitleWithAi')
              : $t('message.ai.dubbings.dubbingWithAi')
          }}
        </h1>
        <span class="body-regular-small neutral-40-light--text text-center">
          {{
            isSubtitle
              ? $t('message.ai.subtitles.subtitleWithAiDescription')
              : $t('message.ai.dubbings.dubbingWithAiDescription')
          }}
        </span>

        <base-btn type="primary" class="mt-4" @click="handleSelectMode">
          {{
            isSubtitle
              ? $t('message.ai.subtitles.subtitleWithAi')
              : $t('message.ai.dubbings.dubbingWithAiBtn')
          }}</base-btn
        >
      </div>
      <div
        class="container-card-options"
        :class="{ 'w-full': isMobileBreakpoint }"
      >
        <svg
          width="28"
          height="34"
          viewBox="0 0 28 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.8208 0.821468C13.4717 0.170594 14.527 0.170594 15.1779 0.821468L25.1779 10.8215C25.8287 11.4723 25.8287 12.5276 25.1779 13.1785C24.527 13.8294 23.4717 13.8294 22.8208 13.1785L15.666 6.02367V25.3333C15.666 26.2538 14.9198 27 13.9993 27C13.0789 27 12.3327 26.2538 12.3327 25.3333V6.02367L5.17786 13.1785C4.52699 13.8294 3.47171 13.8294 2.82084 13.1785C2.16996 12.5276 2.16996 11.4723 2.82084 10.8215L12.8208 0.821468ZM0.666016 32C0.666016 31.0795 1.41221 30.3333 2.33268 30.3333H25.666C26.5865 30.3333 27.3327 31.0795 27.3327 32C27.3327 32.9205 26.5865 33.6666 25.666 33.6666H2.33268C1.41221 33.6666 0.666016 32.9205 0.666016 32Z"
            :fill="$vuetify.theme.dark ? '#697AF2' : '#3F55EE'"
          />
        </svg>
        <h1 class="body-bold-base mt-1">
          {{
            isSubtitle
              ? $t('message.ai.subtitles.sendSubtitle')
              : $t('message.ai.dubbings.sendDubbing')
          }}
        </h1>
        <span class="body-regular-small neutral-40-light--text text-center">
          {{
            isSubtitle
              ? $t('message.ai.subtitles.sendSubtitleDescription')
              : $t('message.ai.dubbings.sendDubbingDescription')
          }}
        </span>

        <base-btn type="secondary" class="mt-4" @click="handleUploadMode">
          {{
            isSubtitle
              ? $t('message.ai.subtitles.sendSubtitleBtn')
              : $t('message.ai.dubbings.sendDubbingBtn')
          }}</base-btn
        >
      </div>
    </div>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'ScreenInitialDubSubTemplate',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    isSubtitle() {
      return this.type == 'Subtitle'
    },
  },
  methods: {
    handleClose() {
      this.$root.$emit(`close${this.type}Modal`)
    },
    handleSelectMode() {
      if (this.type === 'Dubbing') {
        this.$root.$emit('selectDubbingTechScreen')
      } else {
        this.$root.$emit(`screenTitle${this.type}`)
      }
    },
    handleUploadMode() {
      this.$root.$emit(`upload${this.type}Screen`)
    },
  },
  beforeDestroy() {
    this.loading = false
  },
  mounted() {
    this.loading = false
  },
}
</script>
<style lang="scss" scoped>
.container-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.container-card-options {
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  width: 50%;
  height: 330px;
  background: varFigma(neutral-99);
}
.w-full {
  width: 100% !important;
}
</style>
